export default "__VITE_ASSET__BkWgF5dg__"